var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"bg-white",attrs:{"src":require("@/assets/img/service-description.jpg"),"cover":""}})}
var staticRenderFns = []

export { render, staticRenderFns }